export const ACTIVE_LABEL = 'Active';
export const ACTIVATE_SELECTED_LABEL = 'Activate selected';
export const ACTIVATION_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};
export const DEACTIVATE_SELECTED_LABEL = 'Deactivate selected';
export const AI_LEASING = 'AI Leasing';
export const AI_RESIDENT = 'AI Resident';
export const BULK_UPDATE_LABEL = 'Bulk Update';
export const DEFAULT_ROWS_PER_PAGE = 25;
export const EMAIL_DISABLED_VALUE = 'OFF';
export const INACTIVE_LABEL = 'Inactive';
export const LEASING_KEY = 'leasing';
export const NO_PRODUCTS_LABEL = 'No products available.';
export const PRODUCTS_LABEL = 'Products';
export const PROPERTY_LABEL = 'Property';
export const RESIDENT_KEY = 'resident';
export const ROWS_PER_PAGE_OPTIONS = [25, 50, 100, 500];
export const SERVICE_STATUS_LABEL = 'Service Status';
export const SERVICE_STATUS_TOOLTIP = 'Enabling the product & services toggle for the AI Agents will allow users to configure AI across the various channels';

export const TOAST_ERROR_MESSAGE = 'Settings update failed';
export const TOAST_SUCCESS_MESSAGE = 'Settings updated successfully';
export const UPDATE_TYPE = {
  BULK: 'bulk',
  SINGLE: 'single',
};
export const UPDATE_CONFIRMATION = {
  CONFIRM_BUTTON: 'Yes, Deactivate',
  CSV_DOWNLOAD_LABEL: 'CSV file',
  MESSAGE:
    'Deactivating a property will reset its current configurations. This action cannot be undone.',
  DOWNLOAD_MESSAGE_PREFIX: 'Download the current settings in a ',
  DOWNLOAD_MESSAGE_SUFFIX:
    ' in case you want to reactivate and restore previous configurations.',
  TITLES: {
    [UPDATE_TYPE.BULK]: 'Deactivate Selected Properties?',
    [UPDATE_TYPE.SINGLE]: 'Deactivate Property?',
  },
};
